/**
 * @Author:daihua
 * @Date: 2022-04-14 
 * 
 */

import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/statistics/company'
export default {
	//数据统计列表
	getstatisticsList(data) {
		return request.get(`${BASE_URL}/list`, data)
	},
	//数据总览详情
	getstatisticsInfo(data) {
		return request.get(`${BASE_URL}/info`, data)
	},
}
